module.exports = __webpack_public_path__ + "static/media/errorBeep.69458e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/errorBeep.mp3
// module id = 0a1i
// module chunks = 3